/*eslint-disable*/
import React, { useState, Fragment, useRef } from "react";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import { useNavigate } from "react-router-dom";
import ApplicationModal from "./ApplicationModal";
import { Link } from "react-router-dom";
import { MdLocationPin } from "react-icons/md";
import DropdownMenu from "../../components/dot_dropdown_menu/DropdownMenu";
import { Menu, Transition } from "@headlessui/react";
import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import { format } from "date-fns";
import Logo from "../../assets/NonProfit.png";
import SULogo from "../../assets/StartUp.png";
import { Navigate } from "react-router-dom";
import useUserContext from "../../hooks/useUserContext";
import notify from "../../services/toast";
import deleteApplication from "./requests/deleteApplication";
import { MAGIC_NUMBERS } from "../../constant";
import { debounce, showPrompt, generateClassName } from "../../services/util";
import Prompt from "../../components/prompt/Prompt";

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

function ApplicantCard({ application, index }) {
	const navigate = useNavigate();
	const [showApplicantModal, setShowApplicantModal] = useState(false);
	const submissionDate = application.createdAt;
	const submitDate = format(new Date(submissionDate), "MM/dd/yy");
	const [displayPromptMessage, setDisplayPromptMessage] = useState({
		heading: "",
		body: "",
	});
	const deletePromptRef = useRef(null);

	const { userState } = useUserContext();

	const handleDeletePrompt = (application) => {
		showPrompt(
			"Delete Application",
			`Are you sure you want to delete "${application.orgName}'s" application? This action cannot be undone.`,
			deletePromptRef,
			"open",
			setDisplayPromptMessage
		);
	};

	const handleDelete = async () => {
		const response = await deleteApplication(
			application._id,
			userState.accessToken
		);
		if (response.status === "success") {
			notify("Application successfully deleted", "info");
			deletePromptRef.current.closePrompt();
			window.location.reload(true);
			//fetchAdmins(userState.accessToken, 0, keyword, role);
		} else if (response.status === "fail") {
			let displayMessage = "";
			if (Array.isArray(response.message)) {
				displayMessage = response.message[0].message;
			} else {
				displayMessage = response.message;
				if (MAGIC_NUMBERS.SERVER_ERROR_CODES.includes(response.statusCode)) {
					displayMessage =
						"An error has occurred. Please try again later. If this error persists please contact support";
				}
			}
			notify(displayMessage, "error");
		}
	};

	return (
		<>
			<tr key={index}>
				<td className="whitespace-nowrap px-2 py-2 text-sm text-gray-900">
					<div>
						<a href={`/dashboard/profile/${application._id}`} target="_blank">
							<div className="float-left">
								<div className="text-center ">
									{application.logoImage?.small?.url ? (
										<img
											className="h-12 w-12 rounded-full ring-4 ring-white"
											src={application.logoImage.small.url}
										/>
									) : application.logoImage?.logoImage?.url ? (
										<img
											className="h-12 w-12 rounded-full ring-4 ring-white"
											src={application.logoImage.logoImage.url}
										/>
									) : (
										<img
											className="h-12 w-12 rounded-full ring-4 ring-white"
											src={application.type === "give" ? Logo : SULogo}
										/>
									)}
								</div>
							</div>
							<div className="float-left ml-3 font-bold">
								<h1>{application.orgName}</h1>
								<p className="text-gray-500">
									{application.firstName} {application.lastName}
								</p>
							</div>
						</a>
					</div>
				</td>
				<td className="whitespace-nowrap py-4 pl-4 pr-3  text-gray-900 sm:pl-6 uppercase font-bold">
					{application.type}
				</td>
				<td className="">
					<p
						className={`capitalize font-semibold ${
							application.appStatus === "approved"
								? "text-primary-500"
								: application.appStatus === "rejected"
								? "text-red-500"
								: "text-gray-500"
						}`}
					>
						{application.appStatus}
					</p>
				</td>
				<td className="">
					<p
						className={`capitalize  ${
							application.cmStatus === "approved"
								? "text-primary-600"
								: application.cmStatus === "rejected"
								? "text-red-500"
								: "text-gray-500"
						}`}
					>
						{application.cmStatus}
					</p>
				</td>

				<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
					<MdLocationPin className="float-left text-2xl " />
					{application.coLocation}
				</td>
				<td className="whitespace-nowrap py-4 pl-4 pr-3  text-gray-900 sm:pl-6 uppercase font-bold">
					{submitDate}
				</td>
				<td className="whitespace-nowrap py-4 pl-4 pr-3  text-gray-900 sm:pl-6 uppercase font-bold">
					{/*<span className="material-icons-outlined text-red-500">delete</span>*/}
					<Menu as="div" className="relative inline-block text-left">
						<div>
							<Menu.Button>
								<div
									onClick={() => handleDeletePrompt(application)}
									className="material-icons-outlined text-red-500"
								>
									delete
								</div>
							</Menu.Button>
						</div>

						<Transition
							as={Fragment}
							enter="transition ease-out duration-100"
							enterFrom="transform opacity-0 scale-95"
							enterTo="transform opacity-100 scale-100"
							leave="transition ease-in duration-75"
							leaveFrom="transform opacity-100 scale-100"
							leaveTo="transform opacity-0 scale-95"
						>
							<Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
								<div className="py-1">
									<Menu.Item>
										<div className="text-gray-700 block px-4 py-2 text-sm">
											Delete
										</div>
									</Menu.Item>
								</div>
							</Menu.Items>
						</Transition>
					</Menu>
				</td>
			</tr>
			<Prompt
				header={displayPromptMessage.heading}
				body={displayPromptMessage.body}
				ref={deletePromptRef}
				action={handleDelete}
			/>
			<div>
				<ApplicationModal
					open={showApplicantModal}
					onClose={() => setShowApplicantModal(false)}
					application={application}
					status={application.appStatus}
					submissionDate={application.createdAt}
					applicationId={application._id}
					notes={application.notes}
				/>
			</div>
		</>
	);
}

export default ApplicantCard;
